module.exports = __webpack_public_path__ + "static/media/datasheet_listData_row3_havefun.793b13a5.png";